<template>
  <div class="visnet-events">
    <div class="px-3">
      <b-row>
        <NavigationTab />
      </b-row>
    </div>
    <b-container :class="`${isNotFaultEvent ? 'visnet-events__wrapper panel' : 'px-0'}`" fluid>
      <router-view />
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavigationTab from './main-view/navigation-tab';

export default {
  name: 'VisnetHubDefaultCharts',
  components: {
    NavigationTab
  },
  computed: {
    ...mapGetters({
      visnetHub: 'substationVisnetHub/visnetHub'
    }),
    isNotFaultEvent() {
      return this.$route.name !== 'VisnetHubFaultEventsDefault';
    }
  }
};
</script>
